var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "styled-components";
import { CouponBtn } from "./CouponBtn";
import { px2rem } from "../../../utils/css";
const DoubleWrapper = styled.div `
	display: grid;
	gap: ${px2rem(9)};
	grid-template-columns: repeat(2, ${px2rem(171)}); // 设计稿171px
	img {
		width: 100%;
		height: ${px2rem(84)};
		object-fit: cover;
	}
`;
export const Double = (props) => {
    const { coupons = [] } = props, others = __rest(props, ["coupons"]);
    return (React.createElement(DoubleWrapper, null, coupons.map(ele => {
        return React.createElement(CouponBtn, Object.assign({ key: ele.img, coupon: ele }, others));
    })));
};
